export default __webpack_public_path__ + "media/images/casatb/about_us/casatb_aboutus-2a0311c8af634d202fa06ea30cb31417.png";